{
    "AuthoriseButton_Title": "Autorizar",
    "PreAuthoriseButton_Title": "Pré-autorização",
    "Authentication_PreAuthorisation_Successful": "Pré-autorizado",
    "Authentication_Successful": "Autorização concedida",
    "Authentication_Failed": "O processo de autorização falhou.",
    "Authentication_Authenticated": "Este servidor de telefonia já foi autorizado.",
    "Authentication_Status_Title": "Estado de autenticação",
    "Authentication_Status_Warning": "Existe um aviso para esta autorização, pelo que pode tentar voltar a autorizar para resolver o problema.",
    "Authentication_Status_Warning_Range_30100_30199": "Autorização bem-sucedida, mas foi detetado um problema na comunicação com o MS Teams. Contacte o apoio ao cliente da Akixi.",
    "Authentication_Status_Warning_Range_30200_30299": "Autorização bem-sucedida, mas foi detetado um problema na sincronização com o MS Teams. Contacte o apoio ao cliente da Akixi.",
    "NAME": "OAuthButton"
}